
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cookies",
      function () {
        return require("private-next-pages/cookies.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cookies"])
      });
    }
  